/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, inject, Input } from "@angular/core";
import { NavigationService } from "src/app/services/navigation/navigation.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: false,
})
export class FooterComponent {
  @Input() appFooterContainerCSSClass = "";
  @Input() displaySection: "full" | "contact" | "copyright" = "full";

  #scrollService = inject(NavigationService);

  footerContents: FooterMenuItem[] = [
    {
      label: "MENU.COURSES",
      element_id: "about",
    },
    {
      label: "MENU.EXAMS",
      element_id: "movement-stillness",
    },
    {
      label: "MENU.ABOUT_US",
      element_id: "pricing",
    },
  ];

  contactInfo: InfoReusable[] = [
    {
      name: "Edvance เลขที่ xxx/x หมู่ x ตำบลx อำเภอx จังหวัดxxxxx xxxxx",
    },
    {
      name: "088-888-8888",
      icon: "call",
    },
    {
      name: "@edvanceenglish",
      icon: "line",
      url: "https://lin.ee/YgGHwuv",
    },
    {
      name: "edvance.english",
      icon: "tiktok",
      url: "https://www.tiktok.com/@edvance.english?is_from_webapp=1&sender_device=pc",
    },
    {
      name: "edvance_english",
      icon: "instagram",
      url: "https://www.instagram.com/edvance_english",
    },
    {
      name: "Edvance English",
      icon: "fb",
      url: "https://www.facebook.com/profile.php?id=61581948020338",
    },
    // {
    //   name: "@wise.riseplus",
    //   icon: "phone",
    // },
  ];

  currentDateStr: string = new Date().getFullYear().toString();
  constructor() {}

  scrollToElement(id: string) {
    this.#scrollService.scrollElementById(id);
  }
}
interface FooterMenuItem {
  element_id?: string;
  label: string;
  external_url?: string;
}
interface InfoReusable {
  id?: number;
  element_id?: number;
  name?: string;
  icon?: string;
  url?: string;
  color?: string;
  class?: string;
  is_active?: boolean;
}
interface ContactFooter {
  address: string;
  phone: string;
  email: string;
  facebook: string;
  line: string;
}
